import {
  IMqttServiceOptions,
} from 'ngx-mqtt';
import { environment } from 'src/environments/environment';
import { EmqxRecieveMessageModel } from 'src/app/models/common/emqx-receive-message.model';
import { EmqxSubscription } from './emqx_subcription';
import { NotifierHelper } from './common.service';

export class EmqxHelper {
  private isSetupCompleted: boolean = false;
  private isSetupCalling: boolean = false;
  private notifier!: NotifierHelper<EmqxRecieveMessageModel>;
  private connection?: IMqttServiceOptions;
  static readonly #instance = new EmqxHelper();
  private readonly subscriptions: Map<string, EmqxSubscription> = new Map();
  #pendingSubscriptions: string[] = [];
  // #username = '';
  // #password = '';

  private constructor() {}

  static get instance(): EmqxHelper {
    return EmqxHelper.#instance;
  }

  private canSetup(username: string, password: string): boolean {
    return username != '' && password != '' && !this.isSetupCalling;
  }

  setup(
    notifier: NotifierHelper<EmqxRecieveMessageModel>,
    username: string,
    password: string
  ): void {
    try {
      if (this.canSetup(username, password)) {
        this.isSetupCompleted = false;
        this.isSetupCalling = true;
        this.notifier = notifier;
        this.connection = {
          keepalive: 60000,
          hostname: environment.emqx_url,
          port: environment.emqx_port,
          path: '/mqtt',
          clean: true, // Retain session
          connectTimeout: 4000, // Timeout period
          reconnectPeriod: 1000, // Reconnect period
          // Authentication information
          clientId:
            'datastudio-' +
            Date.now() +
            '-' +
            crypto.getRandomValues(new Uint32Array(1)),
          username: username,
          password: password,
          protocol: 'wss',
        };
        this.callSetup(username, password, this.connection);
        this.subscribeToTopics(this.#pendingSubscriptions);
        this.isSetupCompleted = true;
        this.isSetupCalling = false;
      }
    } catch (_) {}
  }

  private canCallSetup(username: string, password: string): boolean {
    return true;
    ///Can add this condition if emqx if failed
    //this.#username != username && this.#password != password;
  }

  onNetworkStatusUpdated() {
    /// Can recall setup if not connected
  }

  private callSetup(
    username: string,
    password: string,
    connection: IMqttServiceOptions
  ) {
    try {
      if (this.canCallSetup(username, password)) {
        for (const subscription of this.subscriptions.values()) {
          subscription.setup(connection, false);
        }
      }
    } catch (_) {}
  }

  disconnect(): void {
    try {
      for (const instance of this.subscriptions.values()) {
        this.#pendingSubscriptions = [];
        instance.disconnect();
        this.isSetupCompleted = false;
      }
    } catch (_) {}
  }

  async subscribe(topic: string): Promise<boolean> {
    if (!this.isSetupCompleted) {
      this.#pendingSubscriptions.push(topic);
    } else {
      this.subscribeToTopics([topic]);
    }
    return false;
  }

  private subscribeToTopics(topics: string[]) {
    if (this.connection) {
      for (const topic of topics) {
        let subscription = this.subscriptions.get(topic);
        if (!subscription) {
          subscription = new EmqxSubscription(this.notifier);
          subscription.setup(this.connection, false);
        }
        subscription.subscribe(topic);
        this.subscriptions.set(topic, subscription);
      }
    }
  }

  unsubscribe(topic: string): void {
    try {
      this.subscriptions.get(topic)?.unsubscribe();
    } catch (_) {}
  }

  publishMessage(topic: string, payload: string): boolean {
    return false;
  }
}
